import { render, staticRenderFns } from "./PersonInGearWithBorder.vue?vue&type=template&id=c8006dac&scoped=true"
import script from "./PersonInGearWithBorder.vue?vue&type=script&lang=js"
export * from "./PersonInGearWithBorder.vue?vue&type=script&lang=js"
import style0 from "./PersonInGearWithBorder.vue?vue&type=style&index=0&id=c8006dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8006dac",
  null
  
)

export default component.exports